import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserMenu from '../user/UserMenu';
import ThemeToggle from './ThemeToggle';

export default function Navbar() {
  const { user } = useAuth();
  const location = useLocation();
  const isListingsPage = location.pathname === '/listings';

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-md z-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img
                src="/assets/holler-finds-logo.png"
                alt="HollerFinds Logo"
                className="h-28 w-auto mr-2"
                style={{ maxHeight: '120px' }}
              />
            </Link>
            {!isListingsPage && (
              <Link
                to="/listings"
                className="text-gray-700 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 px-3 py-2 rounded-md text-sm font-medium"
              >
                View Listings
              </Link>
            )}
          </div>

          <div className="flex items-center space-x-4">
            <ThemeToggle />
            {user ? (
              <>
                <UserMenu />
                {/* Fallback Sign Out Button for Debugging */}
                <button
                  onClick={async () => {
                    const { error } = await import('../../lib/supabase').then(m => m.supabase.auth.signOut());
                    if (!error) window.location.href = '/signin';
                  }}
                  className="ml-2 px-4 py-2 text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Force Sign Out
                </button>
              </>
            ) : (
              <Link
                to="/signin"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
} 